<script>
    export default {
        name: "user-wizard-error-display",
        props: {
            errors: Array,
        }
    }
</script>

<template>
    <div class="d-flex flex-column">
        <div class="text-danger text-center" v-for="error in errors">
            {{error}}
        </div>
    </div>
</template>



